import { marked } from 'marked';
import { InspectDatabase } from './database.structure';
import { TooltipModel } from './types';
import { getTooltipInitializer } from './database.tooltips.initializer';
import { MdHelpers } from '../helpers/mdHelpers';

export default class DatabaseTooltipMethods {
  private db: InspectDatabase;

  constructor(db: InspectDatabase) {
    this.db = db;
  }

  async getAllTooltips(): Promise<TooltipModel[]> {
    // Ensure tooltips are initialized first
    const initializer = getTooltipInitializer(this.db);
    await initializer.initializeTooltips();

    // All tooltips are now in the database (both original and modified)
    return await this.db.tooltips.toArray();
  }

  async getTooltip(key: string): Promise<TooltipModel> {
    // Ensure tooltips are initialized first
    const initializer = getTooltipInitializer(this.db);
    await initializer.initializeTooltips();

    const normalisedKey = MdHelpers.normaliseTooltipKeyComponent(key);

    // Fast O(1) lookup from indexed database
    const result = await this.db.tooltips
      .where('key')
      .equals(normalisedKey)
      .first();

    // Return result or default empty tooltip
    return (
      result ?? {
        key: normalisedKey,
        heading: '',
        markdownBody: '',
        htmlBody: '',
        isModified: false,
      }
    );
  }

  async upsertTooltip(key: string, heading: string, markdownBody: string) {
    await this.db.tooltips.put({
      key: MdHelpers.normaliseTooltipKeyComponent(key),
      heading,
      markdownBody,
      htmlBody: await marked(markdownBody),
      isModified: true,
    });
  }

  async resetAllTooltips() {
    await this.db.tooltips.clear();
  }
}
